<template>
  <div>
    <v-title>
      <span v-if="isResidential || customerID == 0">Customer</span>
      <span v-else>Authorised Representative</span>
    </v-title>
    <v-card>
      <v-card-text>
        <v-container grid-list-md>
          <ValidationObserver ref="observer" v-slot="{ dirty, invalid }">
            <v-form v-model="valid">
              <v-layout wrap>
                <v-flex xs1>
                  <vonex-select
                    ref="Salutation"
                    v-model="salutation"
                    label="Salutation"
                    name="Salutation"
                    item-text="description"
                    item-value="code"
                    :rule="'required'"
                    :items="
                      accountHolders
                        .filter((x) => x.holderType == 'salutation')
                        .sort((a, b) => a.order - b.order)
                    "
                    :options="fieldConditions"
                  ></vonex-select>
                  <!-- <v-select
                    :items="
                      accountHolders
                        .filter((x) => x.holderType == 'salutation')
                        .sort((a, b) => a.order - b.order)
                    "
                    v-model="salutation"
                    label="Salutation"
                    item-text="description"
                    item-value="code"
                    v-validate="'required'"
                    name="salutation"
                    ref="salutation"
                    :error-messages="errors.collect('salutation')"
                  ></v-select> -->
                </v-flex>

                <v-flex v-show="1 == 2" xs6 sm6 lg6 right>
                  <vonex-date
                    ref="dateAdded"
                    v-model="dateAdded"
                    class="form-group"
                    name="dateAdded"
                    label="Date Added"
                    disabled
                    :options="fieldConditions"
                  ></vonex-date>
                  <!-- <label>Date Added</label> -->
                  <!-- <date-picker
                    lang="en-au"
                    name="dateAdded"
                    format="DD/MM/YYYY"
                    value-type="YYYY-MM-DD"
                    v-model="dateAdded"
                    disabled
                    ref="dateAdded" 
                  />-->
                </v-flex>
                <v-flex xs4>
                  <vonex-text
                    ref="First Name"
                    v-model="firstName"
                    label="First Name"
                    name="First Name"
                    lazy-validation="true"
                    :rule="'required'"
                    :options="fieldConditions"
                  ></vonex-text>
                  <!-- <v-text-field
                    label="First Name"
                    name="FirstName"
                    lazy-validation="true"
                    v-validate="'required'"
                    v-model="firstName"
                    :error-messages="errors.collect('FirstName')"
                  ></v-text-field> -->
                </v-flex>
                <v-flex xs4>
                  <vonex-text
                    ref="Surname"
                    v-model="surname"
                    label="Surname"
                    name="Surname"
                    lazy-validation="true"
                    :rule="'required'"
                    :options="fieldConditions"
                  ></vonex-text>
                  <!-- <v-text-field
                    label="Surname"
                    name="Surname"
                    v-model="surname"
                    v-validate="'required'"
                    lazy-validation="true"
                    :error-messages="errors.collect('Surname')"
                  ></v-text-field> -->
                </v-flex>

                <v-flex xs6 sm6 lg6>
                  <vonex-text
                    ref="Email"
                    v-model="email"
                    label="Email"
                    name="Email"
                    lazy-validation="true"
                    :rule="'required|email'"
                    :options="fieldConditions"
                  ></vonex-text>
                  <!-- <v-text-field
                    label="Email"
                    name="Email"
                    v-validate="'required|email'"
                    v-model="email"
                    lazy-validation="true"
                    :error-messages="errors.collect('Email')"
                  ></v-text-field> -->
                </v-flex>
                <v-flex v-if="!isQuote" xs6>
                  <vonex-date
                    ref="Date of Birth"
                    v-model="dob"
                    data-cy-dob
                    label="Date of Birth"
                    name="Date of Birth"
                    editable
                    :rule="isdateOfBirthRequired ? 'required' : ''"
                    data-vv-validate-on="blur"
                  ></vonex-date>
                  <!-- <date-picker
                    data-cy-dob
                    lang="en-au"
                    name="dob"
                    format="DD/MM/YYYY"
                    value-type="YYYY-MM-DD"
                    placeholder="dd/MM/YYYY"
                    v-model="dob"
                    v-validate="isdateOfBirthRequired ? 'required' : ''"
                    editable
                    data-vv-validate-on="blur"
                  ></date-picker>

                  <span v-show="errors.has('dob')" class="error">{{
                    errors.first("dob")
                  }}</span> -->
                </v-flex>
                <v-flex :xs4="isQuote">
                  <vonex-text
                    ref="Phone"
                    v-model="phone"
                    label="Phone"
                    lazy-validation="true"
                    :rule="!mobile || phone ? 'required|phonenumbercustom' : ''"
                    name="Phone"
                    autocomplete="tel-national"
                    :options="fieldConditions"
                  ></vonex-text>
                  <!-- <v-text-field
                      label="Phone"
                      :error-messages="errors.collect('Phone')"
                      lazy-validation="true"
                      v-validate="!mobile || phone ? 'required|phonenumber' : ''"
                      name="Phone"
                      v-model="phone"
                      mask="##########"
                      autocomplete="tel-national"
                    ></v-text-field> -->
                  <span style="font-size: 11px; color: #767676">
                    ** Phone number can be empty if mobile number is already
                    provided.
                  </span>
                </v-flex>
                <v-flex :xs4="isQuote">
                  <vonex-text
                    ref="Mobile"
                    v-model="mobile"
                    label="Mobile"
                    name="Mobile"
                    lazy-validation="true"
                    :rule="'mobilenumber'"
                    autocomplete="mobile"
                    :options="fieldConditions"
                  ></vonex-text>
                  <!-- <v-text-field
                      label="Mobile"
                      name="Mobile"
                      :error-messages="errors.collect('Mobile')"
                      lazy-validation="true"
                      mask="##########"
                      v-validate="
                        !phone || mobile || (isQantas && !mobile)
                          ? 'required|mobilenumber'
                          : ''
                      "
                      v-model="mobile"
                      autocomplete="mobile"
                    ></v-text-field> -->
                </v-flex>
                <v-flex :xs4="isQuote">
                  <vonex-select
                    ref="Job Title"
                    v-model="jobTitle"
                    hide-detail
                    label="Job Title"
                    name="Job Title"
                    item-text="description"
                    item-value="description"
                    :items="
                      accountHolders.filter((x) => x.holderType == 'jobTitle')
                    "
                    :rule="'required'"
                    :options="fieldConditions"
                  ></vonex-select>
                  <!-- <v-select
                      :items="
                        accountHolders.filter((x) => x.holderType == 'jobTitle')
                      "
                      v-model="jobTitle"
                      label="Job Title"
                      item-text="description"
                      item-value="description"
                      v-validate="'required'"
                      name="jobTitle"
                      :error-messages="errors.collect('jobTitle')"
                    ></v-select> -->
                </v-flex>
                <v-flex v-show="isQantas || isFinance">
                  <v-layout>
                    <vonex-checkbox
                      v-if="!allFlags.SOG8484"
                      v-model="isGuarantor"
                      data-cy-guarantor
                      :input-value="isGuarantor"
                      hide-details
                      class="shrink mr-2"
                    ></vonex-checkbox>
                    <!-- <v-checkbox
                        data-cy-guarantor
                        v-model="isGuarantor"
                        hide-details
                        class="shrink mr-2"
                      ></v-checkbox> -->
                    <v-text-field
                      v-if="!allFlags.SOG8484"
                      label="Is Guarantor"
                      :disabled="true"
                    ></v-text-field>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex class="well">
                      <p class="caption">
                        *A guarantor is required for finance and can be added
                        after address entered
                      </p>
                    </v-flex>
                  </v-layout>
                </v-flex>

                <v-flex
                  v-if="
                    customerAuthentication && customerAuthentication.type > 0
                  "
                  xs6
                  sm6
                  md6
                >
                  <vonex-select
                    ref="authenticationType"
                    v-model="customerAuthentication.type"
                    data-vv-as="Authentication Type"
                    name="authenticationType"
                    label="Authentication Type"
                    :items="authDocs"
                    item-value="index"
                    item-text="label"
                    lazy-validation="true"
                    :options="fieldConditions"
                  ></vonex-select>
                  <!-- <v-select
                    data-vv-as="Authentication Type"
                    name="authenticationType"
                    v-validate="'required'"
                    v-model="customerAuthentication.type"
                    label="Authentication Type"
                    :items="authDocs"
                    item-value="index"
                    item-text="label"
                  ></v-select> 
                  <span
                    v-show="errors.has('authenticationType')"
                    class="text-danger"
                    style="color: red"
                    >{{ errors.first("authenticationType") }}</span
                  > -->

                  <v-flex sm6 md6 lg6>
                    <vonex-text
                      ref="authenticationNumber"
                      v-model="customerAuthentication.number"
                      label="Number:"
                      name="authenticationNumber"
                      :rule="'required'"
                      :options="fieldConditions"
                    ></vonex-text>
                    <!-- <v-text-field
                      label="Number:"
                      name="authenticationNumber"
                      data-vv-as="Authentication Number"
                      v-model="customerAuthentication.number"
                    /> 
                    <v-text-field
                      label="Number:"
                      name="authenticationNumber"
                      data-vv-as="Authentication Number"
                      v-model="customerAuthentication.number"
                      v-validate="'required'"
                      :error-messages="errors.collect('authenticationNumber')"
                    /> -->
                  </v-flex>
                </v-flex>
                <v-flex v-show="!readOnly" sm12 lg12>
                  <v-btn
                    v-if="!isSaved"
                    color="primary"
                    :disabled="invalid"
                    @click="createCustomer"
                  >
                    Save
                  </v-btn>
                  <v-btn
                    v-if="isSaved"
                    color="grey"
                    :disabled="invalid"
                    @click="isSaved = false"
                  >
                    Edit
                  </v-btn>
                </v-flex>
                <v-flex v-show="IsAuthorisedRepresentative == 'true'">
                  <v-btn color="primary">Add Primary Contact</v-btn>
                </v-flex>
                <v-flex>
                  <message-alert :component="customer.message"></message-alert>
                </v-flex>
              </v-layout>
            </v-form>
          </ValidationObserver>
        </v-container>
      </v-card-text>
    </v-card>
    <!-- <check-enroll
      v-show="isQantas && customer.customer.customerID > 0"
      ref="qbr"
      :abn="setAbn"
      @qbrUpdated="qbrUpdate"
    ></check-enroll> -->
    <!-- <check-enroll
      v-show="isQantas && customer.customer.customerID > 0"
      ref="qbr"
      :abn="
        company && company.company && company.company.abn
          ? company.company.abn
          : rows &&
            rows[0] &&
            rows[0].customerDetails &&
            rows[0].customerDetails.companyDetails.abn
      "
      @qbrUpdated="qbrUpdate"
    ></check-enroll> -->
  </div>
</template>
<script>
import {
  mapActions,
  mapGetters,
  mapMutations,
  createNamespacedHelpers,
} from 'vuex';
import {
  mapCustomerFields,
  mapDealerFields,
  mapCompanyFields,
} from '@/store/modules/orders';
// import checkEnroll from '@/components/qantas/check-enroll';
const { mapState: mapOrderState } = createNamespacedHelpers(`orders`);
// import NativeSelect from "@/components/NativeSelect";
import Utils from '@/mixins/utils.mixin';

const { mapActions: mapCustomerActions } =
  createNamespacedHelpers(`orders/customer`);
const { mapActions: mapCompanyActions } =
  createNamespacedHelpers(`orders/company`);
const { mapActions: mapOrderActions } = createNamespacedHelpers(`orders`);
const { mapGetters: mapFeatureFlagGetters } =
  createNamespacedHelpers(`orders/featureFlag`);

export default {
  name: 'CustomerDetail',
  // components: { checkEnroll },
  mixins: [Utils],
  props: ['readOnly', 'title', 'IsAuthorisedRepresentative'],
  data() {
    return {
      valid: false,
      industryTypes: [],
      industrySubTypes: [],
      accountHolders: [],
      isDataLoading: false,
      isSaved: false,
      results: [],
      isCompleted: false,
      isLoaded: false,
      authDocs: [
        {
          index: 0,
          label: "Driver's Licence",
        },
        { index: 1, label: 'Medicare Card' },
        { index: 2, label: 'Passport' },
      ],

      date: new Date().toISOString().substr(0, 10),
      menu: false,
      modal: false,
    };
  },
  computed: {
    ...mapOrderState(['company', 'customer', 'rows']),
    ...mapGetters('orders', [
      'isQantas',
      'isResidential',
      'isGrenke',
      'isFinance',
      'isExistingCustomer',
      'isQuote',
    ]),
    ...mapDealerFields({
      dealer: 'dealer.dealerID',
      groupNo: 'dealer.dealer.groupNo',
    }),
    ...mapCustomerFields([
      'customer.customerID',
      'customer.salutation',
      'customer.firstName',
      'customer.surname',
      'customer.dateAdded',
      'customer.contactNo',
      'customer.position',
      'customer.phone',
      'customer.fax',
      'customer.mobile',
      'customer.email',
      'customer.dealerID',
      'customer.companyID',
      'customer.dob',
      'customer.customerAuthentication',
      'customer.jobTitle',
      'customer.isGuarantor',
      'customer.qantasMembershipNo',
      'customer.custType',
      'customer.ubAccountNo',
      'customer.referralCode',
      'customer.referralDate',
      'customer.hasNbnEeService',
    ]),
    ...mapCompanyFields(['company.isdateOfBirthRequired']),
    ...mapFeatureFlagGetters(['allFlags']),
    submitted: function () {
      if (this.customer.message.httpStatus === 200) {
        return 'alert alert-success';
      } else return 'alert alert-danger';
    },
    setAbn() {
      let vm = this;

      if (
        vm.rows[0].customerDetails != undefined &&
        vm.rows[0].customerDetails.companyDetails !== null
      ) {
        let abn = vm.rows[0].customerDetails.companyDetails.abn;
        if (abn !== null) return abn;
        else return '';
      } else return '';
    },
  },
  beforeMount() {
    let vm = this;
    vm.getSupportingData().then((data) => {
      if (data) {
        vm.industryTypes = data.industryTypes;
        vm.industrySubTypes = data.industrySubTypes;
        vm.accountHolders = data.accountHolders;
        vm.dealerID = vm.dealer;
        if (vm.company.company.directorGivenName) {
          vm.updateDirector({
            directorGivenName: vm.company.company.directorGivenName,
            directorSurname: vm.company.company.directorSurname,
          });
        }
      }
    });
  },

  methods: {
    ...mapOrderActions(['addOrder']),
    ...mapCustomerActions([
      'getCustomer',
      'addCustomer',
      'updateCustomer',
      'resetCustomer',
      'getCustomerUBDetails',
    ]),
    ...mapMutations('orders/customer', [
      'updateDirectorName',
      'updateDirector',
    ]),
    ...mapActions('orders/qantas', ['getSupportingData']),
    ...mapCompanyActions(['getCompany']),
    qbrUpdate(val) {
      this.customer.customer.qantasMembershipNo = val;
      this.createCustomer();
    },
    createCustomer: function (event) {
      let vm = this;

      vm.$refs.observer.validate().then((result) => {
        if (result) {
          vm.className = 'alert alert-success';
          if (vm.customerID) {
            if (!vm.isResidential) {
              vm.updateDirector();
              // vm.$refs.qbr.email = vm.email;
            }
            vm.companyID = vm.company.company.companyID;

            let mobileVal = vm.mobile.replace(/\s/g, '');
            let phoneVal = vm.phone ? vm.phone.replace(/\s/g, '') : '';
            vm.mobile = mobileVal;
            vm.phone = phoneVal;
            vm.updateCustomer(vm.customerID, vm.mobile, vm.phone)
              .then(function (data) {
                // vm.$refs.qbr.email = vm.email;
                vm.isSaved = true;

                return;
              })
              .catch(() => {});
          } else {
            let payload = {
              orderType: vm.rows[0].orderType,
              createOnly: vm.$store.getters['orders/changeLessee/createOnly'],
            };

            vm.custType = vm.isResidential ? 'R' : 'B';
            vm.companyID = vm.company.company.companyID;

            //TODO: assign new customer
            //assignNewCustomer

            this.addCustomer(payload)
              .then((data) => {
                if (!vm.isResidential)
                  vm.getCompany(vm.customer.customer.companyID);

                if (vm.customer.customer.customerID > 0)
                  // vm.$refs.qbr.email = vm.email;
                vm.isSaved = true;
                return;
              })
              .catch((err) => {});
          }
          vm.isCompleted = true;
        }
      });
      vm.isDataLoading = false;
      return;
    },
    resetForm: function (event) {
      this.resetCustomer();
    },
  },
  mounted() {
    let vm = this;
    if (vm.customer.customer.customerID > 0)
      vm.getCustomer(vm.customer.customer.customerID);
    if (vm.ubAccountNo > 0) {
      vm.getCustomerUBDetails(vm.ubAccountNo).then((data) => {
        vm.salutation = vm.salutation
          ? vm.salutation.toUpperCase()
          : data.sal.toUpperCase();
        vm.phone = vm.phone ? vm.phone : data.phone;
        vm.mobile = vm.mobile ? vm.mobile : data.mobile;
      });
    } else {
      vm.salutation = vm.salutation ? vm.salutation.toUpperCase() : '';
      let mobileVal = vm.mobile ? vm.mobile.replace(/\s/g, '') : '';
      let phoneVal = vm.phone ? vm.phone.replace(/\s/g, '') : '';
      vm.mobile = mobileVal;
      vm.phone = phoneVal;
    }
    vm.isSaved = false;
    // if (vm.customer.customer.customerID > 0) vm.$refs.qbr.email = vm.email;
    if (vm.isExistingCustomer) vm.$refs.observer.validate();
  },
};
</script>
